import React, { useState } from 'react';
import { Grid, Button } from '@mui/material';
import { AutoComplete } from 'antd';
import { DatePicker } from 'antd';
import type { DatePickerProps } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { fetchBusCityDesDispatch } from '../../reducers/BusReducer';
import {
	setSelectedBusArr,
	setSelectedBusDepart,
} from '../../reducers/UiReducer';
import { useNavigate } from 'react-router-dom';
const Option = AutoComplete.Option;

const SearchEngneBus = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [departDate, setDepartDate] = useState('');
	const { buscity, busDes } = useSelector((state) => state.bus);
	const { busDepart, busArr } = useSelector((state) => state.ui);
	const [filterData, setFilterData] = useState('');
	const [filterData2, setFilterData2] = useState('');
	function disabledDate(current) {
		// Can not select days before today and today
		return current && current < moment().endOf('day');
	}

	const handleChange = (value) => {
		let results = [];
		console.log('value', value.split(',')[1]);
		results =
			buscity &&
			buscity?.result &&
			buscity?.result?.cities?.filter((item) => {
				return (
					item.name.toLowerCase().includes(value.toLowerCase()) ||
					item.state.toLowerCase().includes(value.toLowerCase())
				);
			});
		if (value) {
			dispatch(setSelectedBusDepart(value));
			let formData = {
				source: value.split(',')[1],
			};
			dispatch(fetchBusCityDesDispatch(formData));
		}
		console.log('results', results);
		if (results?.length <= 80) {
			setFilterData(results);
		}
	};
	const opsList =
		filterData?.length > 0 &&
		filterData?.map((l) => {
			return (
				<Option
					value={`${l.name} - ${l.state},${l.id}`}>{`${l.name} - ${l.state},${l.id} `}</Option>
			);
		});

	const handleChange2 = (value) => {
		let results = [];
		results =
			busDes &&
			busDes?.result &&
			busDes?.result?.cities?.filter((item) => {
				return (
					item.name.toLowerCase().includes(value.toLowerCase()) ||
					item.state.toLowerCase().includes(value.toLowerCase())
				);
			});
		console.log('searchresult', results);
		if (value) {
			dispatch(setSelectedBusArr(value));
		}
		if (results?.length < 80) {
			setFilterData2(results);
		}
	};
	const opsList2 =
		filterData2?.length > 0 &&
		filterData2?.map((l) => {
			return (
				<Option
					value={`${l.name} - ${l.state},${l.id}`}>{`${l.name} - ${l.state},${l.id} `}</Option>
			);
		});
	const onChange: DatePickerProps['onChange'] = (date, dateString) => {
		console.log('date', dateString);
		setDepartDate(dateString);
	};
	const handleSubmit = () => {
		let formData = {
			departure_city: busDepart.split(' ')[0],
			arrival_city: busArr.split(' ')[0],
			sourceid: busDepart.split(',')[1],
			destinationid: busArr.split(',')[1],
			dateofjourney: departDate,
		};
		console.log('formData', formData);
		navigate('/searchresultbus', { state: formData });
	};
	return (
		<div>
			<Grid container spacing={1}>
				<Grid item xs={12} sm={12} md={4} lg={4}>
					<AutoComplete
						style={{ width: '100%' }}
						dropdownMenuStyle={{
							maxHeight: 1000,
							overflowY: 'visible',
						}}
						placeholder='From'
						onClick={(e) => console.log('val', e.target.value)}
						onChange={handleChange}>
						{opsList}
					</AutoComplete>
				</Grid>
				<Grid item xs={12} sm={12} md={4} lg={4}>
					<AutoComplete
						style={{ width: '100%' }}
						dropdownMenuStyle={{
							maxHeight: 1000,
							overflowY: 'visible',
						}}
						placeholder='To'
						onChange={handleChange2}>
						{opsList2}
					</AutoComplete>
				</Grid>
				<Grid item xs={12} sm={12} md={4} lg={2}>
					<DatePicker
						disabledDate={disabledDate}
						onChange={onChange}
						style={{ width: '100%', padding: 8 }}
					/>
				</Grid>
				<Grid item xs={12} sm={12} md={4} lg={2}>
					<Button
						onClick={handleSubmit}
						variant='contained'
						style={{
							width: '100%',
							background: 'orange',
							fontWeight: 'bold',
							padding: '7px',
						}}>
						Search
					</Button>
				</Grid>
			</Grid>
		</div>
	);
};

export default SearchEngneBus;
